// src/utils/DescontoDelivery.js
const centavos = valor => Math.round((Number(valor || 0) + Number.EPSILON) * 100);

export function calcularResumoDelivery(valorItens, percentualGeral, percentualPagamento, taxaEntrega, cashback) {
  const itens = Math.max(0, centavos(valorItens));
  const geral = Math.min(10000, Math.max(0, centavos(percentualGeral)));
  const pagamento = Math.min(10000 - geral, Math.max(0, centavos(percentualPagamento)));
  const desconto = Math.min(itens, Math.round(itens * (geral + pagamento) / 10000));
  const descontoGeral = Math.min(desconto, Math.round(itens * geral / 10000));
  const saldo = Math.max(0, itens - desconto + centavos(taxaEntrega));
  const cashbackAplicado = Math.min(saldo, Math.max(0, centavos(cashback)));
  return { descontoGeral: descontoGeral / 100, descontoPagamento: (desconto - descontoGeral) / 100,
    valorDesconto: desconto / 100, valorCashBack: cashbackAplicado / 100, valorTotal: (saldo - cashbackAplicado) / 100 };
}

export const formatarPercentualDelivery = valor => Number(valor || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 });
